import { ConjunctionMode } from "../segments/segment-types";
import {
  PostPurchaseConditionBlock,
  PostPurchaseSegment,
} from "./post-purchase-flow";

export enum PostPurchaseSegmentNumberOperator {
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  EQUAL = "EQUAL",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
}

export const postPurchaseSegmentNumberOperatorToOperatorString: Record<
  PostPurchaseSegmentNumberOperator,
  string
> = {
  [PostPurchaseSegmentNumberOperator.LESS_THAN]: "<",
  [PostPurchaseSegmentNumberOperator.LESS_THAN_OR_EQUAL]: "<=",
  [PostPurchaseSegmentNumberOperator.EQUAL]: "=",
  [PostPurchaseSegmentNumberOperator.GREATER_THAN]: ">",
  [PostPurchaseSegmentNumberOperator.GREATER_THAN_OR_EQUAL]: ">=",
};

export const postPurchaseSegmentNumberOperatorToFriendlyString: Record<
  PostPurchaseSegmentNumberOperator,
  string
> = {
  [PostPurchaseSegmentNumberOperator.LESS_THAN]: "less than",
  [PostPurchaseSegmentNumberOperator.LESS_THAN_OR_EQUAL]:
    "less than or equal to",
  [PostPurchaseSegmentNumberOperator.EQUAL]: "equal to",
  [PostPurchaseSegmentNumberOperator.GREATER_THAN]: "greater than",
  [PostPurchaseSegmentNumberOperator.GREATER_THAN_OR_EQUAL]:
    "greater than or equal to",
};

export const defaultPostPurchaseSegment: PostPurchaseSegment = {
  conjunction: ConjunctionMode.AND,
  conditionBlocks: [],
};

export const defaultPostPurchaseSegmentConditionBlock: PostPurchaseConditionBlock =
  { conjunction: ConjunctionMode.AND, conditions: [] };
